/**
 * Root layout that syncs mobile, header sidenav, and mini sidenav from viewport width.
 */
import React, { useEffect } from "react";

import { useAsterController, useWindowSize } from "context";
import { actionheaderSidenav, actionMiniSidenav, actionMobile } from "context/action";

/**
 * Wraps page content and updates layout flags when the window is resized.
 *
 * @param {{ children: React.ReactNode }} props
 */
const MainLayout = (props) => {
  const { children } = props;

  const [, dispatch] = useAsterController();
  const windowSize = useWindowSize();

  useEffect(() => {
    actionMobile(dispatch, windowSize.width < 768 ? true : false);
    actionheaderSidenav(dispatch, windowSize.width < 992 ? true : false);
  }, [windowSize.width, dispatch]);
  useEffect(() => actionMiniSidenav(dispatch, true), [dispatch]);

  return <>{children}</>;
};

export default MainLayout;
